module.exports = __webpack_public_path__ + "media/AUDIO 01.239d667f.mp3";